declare global {
  interface Window {
    gm_authFailure?: () => void;
  }
}

type AuthFailureListener = () => void;

const listeners = new Set<AuthFailureListener>();
let authFailed = false;
let installed = false;

export class GoogleMapsAuthError extends Error {
  constructor() {
    super('Google Maps JavaScript API authentication failed');
    this.name = 'GoogleMapsAuthError';
  }
}

export const installGoogleMapsAuthFailureHandler = () => {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  const previousHandler = window.gm_authFailure;
  window.gm_authFailure = () => {
    authFailed = true;
    previousHandler?.();
    for (const listener of listeners) listener();
  };
};

export const onGoogleMapsAuthFailure = (listener: AuthFailureListener) => {
  if (authFailed) {
    listener();
    return () => undefined;
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
